import work1 from "../../../assets/images/portfolio/work-1.jpg";
import work2 from "../../../assets/images/portfolio/work-2.jpg";
import work3 from "../../../assets/images/portfolio/work-3.jpg";
import work4 from "../../../assets/images/portfolio/work-4.jpg";
import work5 from "../../../assets/images/portfolio/work-5.jpg";
import work6 from "../../../assets/images/portfolio/work-6.jpg";
import work7 from "../../../assets/images/portfolio/work-7.jpg";
import work8 from "../../../assets/images/portfolio/work-8.jpg";

import client111 from "../../../assets/images/client/111.jpg";
import client122 from "../../../assets/images/client/122.jpg";
import client133 from "../../../assets/images/client/133.jpg";


const portfolioData = [
    {
        id: 1,
        imageUrl: work1,
        title: "Centerd Gallary",
        category: ["profile", "business"],
        client: "Kay Garland",
    },
    {
        id: 2,
        imageUrl: work8,
        title: "Sidebar Stack",
        category: ["business", "finance"],
        client: "Kay Garland",
    },
    {
        id: 3,
        imageUrl: work3,
        title: "Grid – Overlay",
        category: ["profile", "business"],
        client: "Kay Garland",
    },
    {
        id: 4,
        imageUrl: work2,
        title: "Distinctive",
        category: ["marketing"],
        client: "Kay Garland",
    },
    {
        id: 5,
        imageUrl: work6,
        title: "Sustainable",
        category: ["finance", "marketing"],
        client: "Kay Garland",
    },
    {
        id: 6,
        imageUrl: work5,
        title: "Popup Hover",
        category: ["profile", "marketing"],
        client: "Kay Garland",
    },
    {
        id: 7,
        imageUrl: work7,
        title: "Vendor",
        category: ["business"],
        client: "Kay Garland",
    },
    {
        id: 8,
        imageUrl: work4,
        title: "Slider Cover",
        category: ["marketing"],
        client: "Kay Garland",
    },
];

const testimonialData = [
    {
        id: 1,
        review:
            'Their separate existence is a myth. For science music sport etc Europe uses the same vocabulary. The languages only differ in their grammar, their pronunciation and their most common words. Everyone realizes why a new common language',
        image: client111,
        designation: "Founder",
        name: "Willimore Wilson",
    },
    {
        id: 2,
        review:
            "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a normal of letters, as opposed to using making it look like readable English.",
        image: client122,
        designation: "Ceo",
        name: "Charley Brown",
    },
    {
        id: 3,
        review:
            "Looking for an event WordPress theme? Look no further—we’ve got pre-built websites for over 20 different types of events: birthday party, wedding, course launch, marketing event, conference, seasonal event.",
        image: client133,
        designation: "Manager",
        name: "Norden Sophie",
    },
];

export { portfolioData, testimonialData };